import Vue from 'vue'
import Router from 'vue-router'
import ImMain from '@/pages/imMain'

Vue.use(Router)
Vue.use(require('vue-wechat-title'))

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'ImMain',
      component: ImMain,
      meta: {
        title: 'IM聊天工具'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js